import {ExceptionError} from '../exception'
import {Request} from '../request'
import {
  IActionCompanyGroupResponse,
  IGetCompanyGroupResponse,
  ICompanyGroup,
} from '../../interface/company-group/company-group'
import {IPageOption} from '../../interface/paging/paging'
import {API_PATH} from '../../constants/api-path'
import {IApiResponse} from '../../interface/api-response/api-response'

export class GetCompanyGroupService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client.get<IGetCompanyGroupResponse>(API_PATH.COMPANY_GROUP, {
        params: options,
      })
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateCompanyGroupService extends Request {
  async request(options?: ICompanyGroup) {
    try {
      const {data} = await this.client.post<IActionCompanyGroupResponse>(
        API_PATH.COMPANY_GROUP,
        options
      )
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateCompanyGroupService extends Request {
  async request(options?: ICompanyGroup) {
    try {
      const {data} = await this.client.patch<IActionCompanyGroupResponse>(
        API_PATH.COMPANY_GROUP,
        options
      )
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class DeleteCompanyGroupService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .delete<IApiResponse<any>>(`${API_PATH.COMPANY_GROUP}/${id}`)
        .then((d) => d.data)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetCompanyGroupLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.COMPANY_GROUP}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
